import React, {useMemo} from 'react';
import {IFileTaskSingleVoyage} from "@containers/singleVoyage/tasks/types";
import ImageListCustom from "@ui/imageListCustom/ImageListCustom";
import {IImagePreview} from "@ui/imageListCustom/types";


interface IProps {
    files: IFileTaskSingleVoyage[]
}

const TasksFilesListSingleVoyage = ({files}: IProps) => {

    const images: IImagePreview[] = useMemo(() => {
        return files?.map((file) => {
            return {
                src: file.fileUrl,
                dateAdd: file.uploadedAt
            }
        })
    }, [files])
    return (
        <ImageListCustom images={images}/>
    );
};

export default TasksFilesListSingleVoyage;